import React, { useEffect, useState } from "react";
import ItemShops from "../components/ItemShops";
import Footer from "../components/Footer";
import NavBar from "../components/NavBar";
import FilterBar from "../components/FilterBar";
import { useNavigate } from "react-router-dom";
import { get, query as dbQuery, orderByChild, limitToLast } from "firebase/database";
import ItemShopShimmer from "../components/home/ItemShopShimmer";
import { usersDbRef } from "../utils/dbRefs";
import { useSearchParams } from "react-router-dom";
import QuickContactDialog from "../components/home/QuickContactDialog";
import ShopDetailsModal from "../components/home/ShopDetailsModal";


function MarketPlace() {
    const [isQuickContactOpen, setIsQuickContactOpen] = useState(false);
    const [showDetails, setShowDetails] = useState(false);
    const [selectedShop, setSelectedShop] = useState(null);
    const [query, setQuery] = useState("");
    const [activeFilter, setActiveFilter] = useState("all");
    const [areaQuery, setAreaQuery] = useState("");
    const [shops, setShops] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filteredShops, setFilteredShops] = useState([]);
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const fullAddress = selectedShop?.address
        ? `${selectedShop.address.city || ""}, ${selectedShop.address.province || ""}`.replace(", ,", ",")
        : "No Address Provided";


    useEffect(() => {
        const urlFilter = searchParams.get("filter");

        if (urlFilter) {
            setActiveFilter(urlFilter);
        }
    }, [searchParams]);

    const handleShopClick = (shop) => {
        setSelectedShop(shop);
    }

    const openQuickContact = (shop) => {
        setIsQuickContactOpen(true);
        setSelectedShop(shop);
    }

    const closeQuickContact = () => {
        setIsQuickContactOpen(false);
    }
    const openMoreInfo = (shop) => {
        setSelectedShop(shop);
        setShowDetails(true);
    };

    const closeMoreInfo = () => {
        setShowDetails(false);
        setSelectedShop(null);
    }




    useEffect(() => {
        const fetchShops = async () => {
            try {
                setLoading(true);

                const usersRef = dbQuery(
                    usersDbRef,
                    orderByChild("createdAt"),
                    limitToLast(20) // get latest users first
                );

                const snapshot = await get(usersRef);

                if (!snapshot.exists()) {
                    setShops([]);
                    return;
                }

                const data = snapshot.val();


                const shopsList = Object.values(data)
                    .filter((user) => user.type !== "admin" && (user.status === "approved" || !user.status))
                    .sort((a, b) => b.createdAt - a.createdAt);

                setShops(shopsList);

            } catch (error) {
                console.error("Error fetching shops:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchShops();
    }, []);

    useEffect(() => {
        setFilteredShops(shops);
    }, [shops]);

    useEffect(() => {
        let result = [...shops];

        // 🏷 Shop type filter
        if (activeFilter !== "all") {
            result = result.filter((shop) => {
                if (activeFilter === "printShop") return shop.type === "printShop";
                if (activeFilter === "specialist") return shop.type === "specialist";
                if (activeFilter === "supplier") return shop.type === "supplier";
                return true;
            });
        }

        // 📍 Area filter
        if (areaQuery.trim()) {
            const area = areaQuery.trim().toLowerCase();

            result = result.filter((shop) => {
                const address = shop.address
                    ? `${shop.address.street || ""} ${shop.address.city || ""} ${shop.address.province || ""} ${shop.address.postalCode || ""}`.toLowerCase()
                    : "";

                return address.includes(area);
            });
        }

        // 🔍 Search filter (search everything in ONE filter)
        if (query.trim()) {
            const search = query.trim().toLowerCase();

            result = result.filter((shop) => {
                const shopName = (shop.shopName || "").toLowerCase();

                const address = shop.address
                    ? `${shop.address.street || ""} ${shop.address.city || ""} ${shop.address.province || ""} ${shop.address.postalCode || ""}`.toLowerCase()
                    : "";

                const selectedSupplies = Array.isArray(shop.selectedSupplies)
                    ? shop.selectedSupplies.join(" ").toLowerCase()
                    : "";

                const customSupplies = Array.isArray(shop.customSupplies)
                    ? shop.customSupplies.join(" ").toLowerCase()
                    : "";

                const type = (shop.type || "").toLowerCase();

                const description = (shop.description || "").toLowerCase();

                return (
                    shopName.includes(search) ||
                    address.includes(search) ||
                    type.includes(search) ||
                    description.includes(search) ||
                    selectedSupplies.includes(search) ||
                    customSupplies.includes(search)
                );
            });
        }

        setFilteredShops(result);
    }, [shops, query, activeFilter, areaQuery]);

    return (
        <div className="bg-background min-h-full flex flex-col font-['Plus_Jakarta_Sans',sans-serif]">
            <NavBar />
            <section className="max-w-[1200px] mx-auto w-full px-[16px] md:px-[40px] py-[32px] md:py-[48px] flex flex-col gap-[24px]">
                <a class="inline-flex items-center gap-[6px] font-semibold text-[13px] text-[#717182] hover:text-[#212326] transition-colors no-underline self-start" href="/" data-discover="true">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-arrow-left w-[14px] h-[14px]">
                        <path d="m12 19-7-7 7-7"></path>
                        <path d="M19 12H5"></path>
                    </svg>
                    Back to Home
                </a>
                <div className="flex flex-col md:flex-row md:items-end justify-between gap-[12px]">
                    <div>
                        <h2 className="font-semibold text-[26px] md:text-[32px] text-[#212326] mb-[4px]">Marketplace</h2>
                    </div>
                    <div className="relative w-full md:w-[340px]">
                        <input
                            type="text"
                            placeholder="Search shops, suppliers, services..."
                            value={query}
                            onChange={(e) => setQuery(e.target.value)}
                            className="w-full h-[44px] rounded-[12px] border border-[#e4e5e7] pl-[40px] pr-[16px] font-medium text-[16px] text-[#212326] placeholder:text-[#9298a0] focus:outline-none focus:border-[#ff5323] bg-white transition-colors"
                        />

                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-search absolute left-[14px] top-1/2 -translate-y-1/2 w-[18px] h-[18px] text-[#9298a0]">
                            <circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.3-4.3"></path>
                        </svg>
                    </div>
                </div>
                <section className="max-w-[900px] mx-auto px-6 py-16 text-center flex flex-col items-center">

                    <div className="w-20 h-20 rounded-full bg-[#FFF1EC] flex items-center justify-center mb-8">
                        <span className="text-4xl">🚀</span>
                    </div>

                    <h1 className="text-[42px] font-bold text-[#212326] leading-tight">
                        Going Live August 17
                    </h1>

                    <p className="mt-6 text-lg text-[#717182] max-w-[650px] leading-8">
                        We're preparing South Africa's dedicated print marketplace.
                        Register your business today so you'll be one of the first
                        businesses customers discover when we go live.
                    </p>

                    <button
                        onClick={() => navigate("/onboarding/plan")}
                        className="mt-10 bg-[#ff5323] hover:bg-[#e64a1f] text-white font-semibold px-8 py-4 rounded-xl transition"
                    >
                        List Your Store
                    </button>

                    <p className="mt-4 text-sm text-[#9298a0]">
                        Join before launch and be ready for customers from day one.
                    </p>

                </section>


            </section>

            <Footer />

        </div>
    );
}

export default MarketPlace;
